import axios from '../axios';
import type { ApiEnvelope } from './types';

export type SsoExchangeResponse = {
  token: string;
  token_type?: string;
  expires_in?: number | null;
  user?: {
    id: string;
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    phone?: string | null;
    user_type?: string | null;
    roles?: Array<{ role_name: string }>;
  };
  redirect_path?: string | null;
};

const ssoService = {
  async exchangeSsoToken(token: string) {
    const response = await axios.post<ApiEnvelope<SsoExchangeResponse>>(
      '/v1/auth/manpro/sso/exchange',
      { token },
    );

    return response.data;
  },
};

export default ssoService;
